import { createEnv } from "@t3-oss/env-nextjs";

import { z } from "zod";



export const env = createEnv({
  server: {
    NODE_ENV: z.enum(["development", "production"]),
    ANALYZE: z.enum(["true", "false"]).optional().default("false"),
    // POSTHOG_API_KEY: z.string().min(51, "PostHog personal API key is required"),
    // POSTHOG_ENV_ID: z.string().min(5, "PostHog environment ID is required"),
    // SENTRY_AUTH_TOKEN: z.string().min(1, "Sentry auth token is required"),
    DB_DIALECT: z.enum(["postgresql", "mysql", "sqlite"]),
    DATABASE_URL: z.string().min(1, "Database URL is required"),
  },
  client: {
    NEXT_PUBLIC_APP_ENV: z.enum(["development", "staging", "production"]),
    NEXT_PUBLIC_APP_TITLE: z.string().min(1, "App title is required"),
    NEXT_PUBLIC_APP_NAME: z.string().min(1, "App name is required"),
    NEXT_PUBLIC_APP_URL: z.url("App URL is required"),
    NEXT_PUBLIC_APP_DESCRIPTION: z.string().min(1, "App description is required"),
    NEXT_PUBLIC_APP_CATEGORY: z.string().min(1, "App category is required"),
    NEXT_PUBLIC_APP_KEYWORDS: z.string().min(1, "App keywords are required"),
    NEXT_PUBLIC_API_BASE_URL: z.string().url("API base URL is required"),
    NEXT_PUBLIC_THUMBNAIL_DOMAIN: z.string().url("Thumbnail domain is required"),
    NEXT_PUBLIC_CLOUDFRONT_DOMAIN: z.string().url("CloudFront domain is required"),
    // NEXT_PUBLIC_GTM_KEY: z.string().min(1, "GTM key is required"),
    // PostHog related public envs (optional, enable analytics when present).
    // Treat empty strings as undefined so builds don't fail when unset.
    // NEXT_PUBLIC_POSTHOG_KEY: z.preprocess(
    //   (v) => (v === "" ? undefined : v),
    //   z.string().min(1).optional(),
    // ),
    // NEXT_PUBLIC_POSTHOG_HOST: z.preprocess(
    //   (v) => (v === "" ? undefined : v),
    //   z.string().url().optional(),
    // ),
    // NEXT_PUBLIC_POSTHOG_INGEST: z.preprocess(
    //   (v) => (v === "" ? undefined : v),
    //   z.string().optional(),
    // ),
    // NEXT_PUBLIC_POSTHOG_ENVIRONMENT: z
    //   .enum(["development", "staging", "production"]).optional(),
  },
  runtimeEnv: {
    // Private
    NODE_ENV: process.env.NODE_ENV,
    ANALYZE: process.env.ANALYZE,
    // POSTHOG_API_KEY: process.env.POSTHOG_API_KEY,
    // POSTHOG_ENV_ID: process.env.POSTHOG_ENV_ID,
    // SENTRY_AUTH_TOKEN: process.env.SENTRY_AUTH_TOKEN,
    DB_DIALECT: process.env.DB_DIALECT,
    DATABASE_URL: process.env.DATABASE_URL,
    // Public
    NEXT_PUBLIC_APP_ENV: process.env.NEXT_PUBLIC_APP_ENV,
    NEXT_PUBLIC_APP_TITLE: process.env.NEXT_PUBLIC_APP_TITLE,
    NEXT_PUBLIC_APP_NAME: process.env.NEXT_PUBLIC_APP_NAME,
    NEXT_PUBLIC_APP_URL: process.env.NEXT_PUBLIC_APP_URL,
    NEXT_PUBLIC_APP_DESCRIPTION: process.env.NEXT_PUBLIC_APP_DESCRIPTION,
    NEXT_PUBLIC_APP_CATEGORY: process.env.NEXT_PUBLIC_APP_CATEGORY,
    NEXT_PUBLIC_APP_KEYWORDS: process.env.NEXT_PUBLIC_APP_KEYWORDS,
    NEXT_PUBLIC_API_BASE_URL: process.env.NEXT_PUBLIC_API_BASE_URL,
    NEXT_PUBLIC_THUMBNAIL_DOMAIN: process.env.NEXT_PUBLIC_THUMBNAIL_DOMAIN,
    NEXT_PUBLIC_CLOUDFRONT_DOMAIN: process.env.NEXT_PUBLIC_CLOUDFRONT_DOMAIN,
    // NEXT_PUBLIC_GTM_KEY: process.env.NEXT_PUBLIC_GTM_KEY,
    // NEXT_PUBLIC_POSTHOG_KEY: process.env.NEXT_PUBLIC_POSTHOG_KEY,
    // NEXT_PUBLIC_POSTHOG_HOST: process.env.NEXT_PUBLIC_POSTHOG_HOST,
    // NEXT_PUBLIC_POSTHOG_INGEST: process.env.NEXT_PUBLIC_POSTHOG_INGEST,
    // NEXT_PUBLIC_POSTHOG_ENVIRONMENT: process.env.NEXT_PUBLIC_POSTHOG_ENVIRONMENT,
  },
});
